module.exports = __webpack_public_path__ + "img/silver_tip.620766fc.jpg";